SupportDropDownModel = require('./dropdowns')
SupportDropDownCombinationsModel = require('./dropdown_combinations')

class SupportInbentaModel
  constructor: ->
    @init(null)
    @dropDowns = new SupportDropDownModel()
    @dropDownCombinations = new SupportDropDownCombinationsModel()

  init: (currentOrder) ->
    @isCurrentOrderSelected = if currentOrder then true else false
    window.Groupon.Support.Inbenta = {}
    @flexibleStepThree = null
    @displayStatus = null
    @displayNotes = null
    @externalDealNotes = null

  getCategory: () ->
    Groupon.Support.Inbenta.Category

  getSubCategory: () ->
    Groupon.Support.Inbenta.SubCategory

  getSearchInputIssue: () ->
    Groupon.Support.Inbenta.searchInputIssue

  getContentId : () ->
    Groupon.Support.Inbenta.ContentId

  setSubCategory: (subCategory) ->
    Groupon.Support.Inbenta.SubCategory = subCategory

  setCategory: (category) ->
    Groupon.Support.Inbenta.Category = category

  setContentId : (contentId) ->
    Groupon.Support.Inbenta.ContentId = contentId

  setSearchInputIssue: (searchInputIssue) ->
    Groupon.Support.Inbenta.searchInputIssue =  searchInputIssue

  onUnloadStepOne: () ->
    if Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled() then $.event.trigger('inbenta-help-wizard-step1-completed')

  onInitStepTwo: () ->
    if Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled() then $.event.trigger('initiate-inbenta-help-wizard-step2')

  onInitStepThree: () ->
    if Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()
      $.event.trigger('initiate-inbenta-help-wizard-step3')
    else if window.shouldShowOptimizedChannel() || window.shouldShowFlexibleChannel()
      $.event.trigger('inbenta-hash-change', ['#contact-us' , '#contact-us'])

  extendParams: (params) ->
    _.extend(Groupon.Support.Inbenta, params)

module.exports = SupportInbentaModel
